import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import localData from "dayjs/plugin/localeData";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localData);

export default dayjs;
